export { default as NCarousel, carouselProps } from './src/Carousel';
export { default as NCarouselItem } from './src/CarouselItem';
